var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip || _vm.defaultTooltip),expression:"tooltip || defaultTooltip"}],class:[{ 'v-data-with-info__underline': _vm.showUnderline }, { 'cursor-help': _vm.showUnderline }],attrs:{"data-cy":_vm.dataCy}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }